module.exports = "<input type=\"text\" class=\"form-control\">"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/dynamic-dropdown/dynamic-dropdown.component.html
// module id = ./src/app/shared/components/dynamic-dropdown/dynamic-dropdown.component.html
// module chunks = main